<template>
    <div class="uk-padding uk-background-muted uk-margin-remove-top">
        <div class="uk-container">
            <div uk-grid>
                <div class="uk-width-2-5@m uk-padding" style="margin-right: -120px; z-index: 1;">
                    <div class="" style="background-color: rgb(3, 56, 96); height: 100%; border-radius: 5px" >
                        <div class="uk-padding">
                            <h3 class=" uk-light uk-text-left uk-text-uppercase " style="font-variant: all-small-caps; font-family: 'Nanum Gothic', sans-serif ">Admissions</h3>
                            <hr>
                            <ul class="uk-list uk-list-bullet uk-text-left">
                               <!-- <li><router-link class="uk-light uk-text-left linkColor" to="/applicationforms">Application Forms</router-link></li>-->
                                <li><router-link class="uk-light uk-text-left linkColor" to="/financialaid">Financial Aid</router-link></li>
                                <li><router-link class="uk-light uk-text-left linkColor" to="/graduateadmission">Graduate Requirements</router-link></li>
                                <li><router-link class="uk-light uk-text-left linkColor" to="/tuitionfees">Tuition & Fees</router-link></li>
                                <li><router-link class="uk-light uk-text-left linkColor" to="/undergradadmission">Undergraduate Requirements</router-link></li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="uk-width-3-5@m" style=" z-index: 0;">
                    <img src="../../assets/admissionBg.jpg"  alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "admissions"
    }
</script>

<style scoped>
    .linkColor{
        color: white;
        font-variant: all-small-caps;
        font-size: 18px;
    }
    h3{
        color: rgba(255, 215, 3,0.9);
        font-family: soleil, sans-serif !important;
        font-style: normal;
        font-weight: 500;
    }
    @media screen and (max-width:600px){


        h3{
            font-size: 1.1em !important;
        }
        li{
            font-size: 0.9em !important;
        }
        a{
            font-size: 0.9em !important;
        }


    }
</style>
